
// 处理一下表格显示需要的数据或者编辑器需要的数据
import { getopenuserlist } from "@/port/clientSide/multipleChoice";
import { setCustomData, getCustomVal } from '@/util/customData'
import {
  getoherappvaldatalist,
  getapprovalreportdatalist,
  apiGetapprovalselection,
  getuserapprovinglist,
  getapproving } from "@/port/clientSide/oaExamineAudit";
import {
  getopenreportformlist,
  getapifielddatalist } from "@/port/clientSide/workbench";
import {
  lookqrcoreddata,
  qrcoreddata
} from "@/port/clientSide/oaExamineAudit";
import { apiGetapprovalreport, getapprovalreportlist } from "@/port/admins/report";
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import dayjs from 'dayjs'
import util from '@/api/util'
import { cloneDeep } from "lodash";

class DealPrintData {
  deptGroup = {}
  otherData = {}
  // 处理单选存储值
  async dealRadioLabel (formdata, ruleList = []) {
    if (ruleList && ruleList.length > 0) {
      ruleList.forEach(item => {
        // 本表的一级
        if (item.type === 'radio' && Array.isArray(item.sels) && item.sels.length > 0 && typeof item.sels[0] === 'object') {
          formdata[`${item.title}_${item.type}`] = this.getRadioLabel(formdata[`${item.title}_${item.type}`], item.sels)
        } else if (item.type === 'details' ) { // 本表明细的处理
          if (item.list.length > 0) {
            // 先去循环本表明细的模板
            item.list.forEach ((list) => {
              // 本表明细的模板存在符合的数据
              if (list.type === 'radio'&& Array.isArray(list.sels) && list.sels.length > 0 && typeof list.sels[0] === 'object') {
                // 循环本表明细一条一条的跑
                formdata[`${item.title}_${item.type}`].forEach(detailData => {
                  detailData[`${list.title}_${list.type}`] = this.getRadioLabel(detailData[`${list.title}_${list.type}`], list.sels)
                })
              }
            })
          }
        }
      })
    }
    return formdata
  }
  // 单选显示值匹配
  getRadioLabel (val, item) {
    if (!item || item.length === 0) return val
    for (const i of item) {
      if (i.value === val) return i.label
    }
    return val
  }
  // 获取联系人其他数据
  async getRelationUserInfo (formdata, canvasChildren = []) {
    let resFormdata = JSON.parse(JSON.stringify(formdata))
    const userMsg = localStorage.getItem('userMsg') ? JSON.parse(localStorage.getItem('userMsg')) : {}
    const canvasChildrenObj = {}
    canvasChildren.forEach(item => {
      canvasChildrenObj[item.title + '_' + item.type] = cloneDeep(item)
    })
    const userIds = this.getUserIds(resFormdata, canvasChildrenObj).filter(item => { return item !== undefined })
    // 存在用户再发起请求
    if (userIds.length > 0) {
      const { data } = await getopenuserlist({userids: userIds.join(), curpage: 0, pagesize: 1000})
      const filterData = {}
      data.forEach(item => {
        filterData[item.userId] = this.filterUserInfo(item, userMsg)
      })
      resFormdata = this.setUserInfo(resFormdata, filterData)
    }
    return resFormdata
  }
  // 获取需要请求的联系人uid
  getUserIds (formdata, canvasChildrenObj) {
    const uidList = []
    for (let key in formdata) {
      const value = formdata[key]
      if (key.search('relation-user') !== -1 && Array.isArray(value)) {
        // 本表的处理
        let isAdd = true
        if (canvasChildrenObj && JSON.stringify(canvasChildrenObj) !== '{}') {
          if (canvasChildrenObj[key] && canvasChildrenObj[key].userKey) {
            const userKey = canvasChildrenObj[key].userKey
            // 如果存在'-data'就使用表单的数据 不用获取最新的
            if (userKey.search('-data') !== -1) {
              isAdd = false
            }
          }
        }
        if (isAdd) {
          value.forEach(item => {
            if (item && item.userId) {
              uidList.push(item.userId)
            }
          })
        }
      } else if (key.search('details') !== -1) {
        // 本表的明细
        value.forEach(detailsItem => {
          if (detailsItem instanceof Object) {
            for (let detailsItemKey in detailsItem) {
              const detailsItemVal = detailsItem[detailsItemKey]
              if (detailsItemKey.search('relation-user') !== -1 && Array.isArray(detailsItemVal)) {
                detailsItemVal.forEach( item => uidList.push(item.userId) )
              }
            }
          }
        })
      } else if (!isNaN(Number(key))) {
        // 纯数字就是其他表
        const otherTableData = formdata[key]
        for (let otherTableKey in otherTableData) {
          const otherTableVal = otherTableData[otherTableKey]
          if (otherTableKey.search('relation-user') !== -1 && Array.isArray(otherTableVal)) {
            // 他表的处理
            otherTableVal.forEach( item => {
              item.forEach( _item => uidList.push(_item.userId) )
            })
          } else if (otherTableKey.search('details') !== -1) {
            otherTableVal.forEach(item => {
              // 他表的每条数据
              item.forEach(detailsItem => {
                // 他表明细的每条数据
                if (detailsItem instanceof Object) {
                  for (let detailsItemKey in detailsItem) {
                    // 他表明细的每条数据中的每个字段
                    const detailsItemVal = detailsItem[detailsItemKey]
                    if (detailsItemKey.search('relation-user') !== -1 && Array.isArray(detailsItemVal)) {
                      detailsItemVal.forEach( _item => uidList.push(_item.userId) )
                    }
                  }
                }
              })
            })
          }
        }
      }
    }
    // 去除重复的uid
    const uniqueArr = Array.from(new Set(uidList))
    return uniqueArr
  }
  setUserInfo (formdata, userList) {
    const resData = JSON.parse(JSON.stringify(formdata))
    for (let key in formdata) {
      const value = formdata[key]
      if (key.search('relation-user') !== -1 && Array.isArray(value)) {
        // 本表的处理
        value.forEach((item, index) => {
          if (item && item.userId) {
            resData[key][index] = { ...resData[key][index], ...userList[item.userId] }
          }
        })
      } else if (key.search('details') !== -1) {
        // 本表的明细
        value.forEach((detailsItem, detailsIndex) => {
          if (detailsItem instanceof Object) {
            for (let detailsItemKey in detailsItem) {
              const detailsItemVal = detailsItem[detailsItemKey]
              if (detailsItemKey.search('relation-user') !== -1 && Array.isArray(detailsItemVal)) {
                detailsItemVal.forEach( (item, index) => {
                  resData[key][detailsIndex][detailsItemKey][index] = userList[item.userId]
                } )
              }
            }
          }
        })
      } else if (!isNaN(Number(key))) {
        // 纯数字就是其他表
        const otherTableData = formdata[key]
        for (let otherTableKey in otherTableData) {
          const otherTableVal = otherTableData[otherTableKey]
          if (otherTableKey.search('relation-user') !== -1 && Array.isArray(otherTableVal)) {
            // 他表的处理
            otherTableVal.forEach( (item, index) => {
              item.forEach( (_item, _index) => {
                resData[key][otherTableKey][index][_index] = userList[_item.userId]
              } )
            })
          } else if (otherTableKey.search('details') !== -1) {
            otherTableVal.forEach((item, index) => {
              // 他表的每条数据
              item.forEach((detailsItem, detailsIndex) => {
                // 他表明细的每条数据
                if (detailsItem instanceof Object) {
                  for (let detailsItemKey in detailsItem) {
                    // 他表明细的每条数据中的每个字段
                    const detailsItemVal = detailsItem[detailsItemKey]
                    if (detailsItemKey.search('relation-user') !== -1 && Array.isArray(detailsItemVal)) {
                      detailsItemVal.forEach( (_item, _index) => {
                        resData[key][otherTableKey][index][detailsIndex][detailsItemKey][_index] = userList[_item.userId]
                      } )
                    }
                  }
                }
              })
            })
          }
        }
      }
    }
    return resData
  }
  // 过滤联系人信息
  filterUserInfo(userInfo, userMsg) {
    const resInfo = {}
    // 需要的字段
    const userKey = ['realname', 'userId', 'username', 'elecsign', 'avatar', 'idcard', 'orgname', 'schoolname', 'phone', 'facephotos', '角色', '部门', '电子签名', 'listschool']
    userKey.forEach(item => {
      if(item === 'elecsign') {
        resInfo[item] = userInfo['电子签名'] || userInfo[item] || ''
      } else if (item === 'schoolname') {
        if (userMsg && userMsg.schoolMsg) {
          const schoolsName = userMsg.schoolMsg.name
          resInfo[item] = schoolsName || ''
        }
      } else {
        resInfo[item] = userInfo[item] || ''
      }
    })
    return resInfo
  }
  // 处理默认字段
  handleDefaultKey(item, formdata) {
    let result
    switch (item) {
      case '申请人_relation-user': {
        const val = formdata.user ? formdata.user : { realname: formdata.name, userId: formdata.userId, orgname: formdata.orgname }
        result = [val]
        break;
      }
      case '单号_text': {
        const status = formdata.approving !== undefined ? formdata.approving.orders : formdata.orders
        result = status || 0
        break;
      }
      case '状态_status': {
        const statusList = ['进行中', '已通过', '未通过', '已撤回']
        const status = formdata.approving !== undefined ? formdata.approving.status : formdata.status
        result = statusList[status]
        break;
      }
      case '提交时间_date': {
        result = dayjs(formdata.ctime).format('YYYY-MM-DD')
        break;
      }
      case '归档状态_status': {
        const isarchive = formdata.approving !== undefined ? formdata.approving.isarchive  : formdata.isarchive
        result = isarchive ? '已归档' : '未归档'
        break;
      }
    }
    return result
  }

  // 获取其他表的信息
  // 自定义详情页获取其他数据源的模板
  async getOtherApproval(printConfig, printFormdata, spaceid, upaceid, customData) {
    return new Promise((resolve, reject) => {
      ( async () => {
        try {
          // 如果是打印报表， 其他表、工坊的数据就整理出来返回出去
          // 清空一下工坊数据、其他表的数据
          let resOtherFormdata = {}
          let resOtherOriginalFormdata = {}
          const ids = []
          let reportList = []
          printConfig.dataSource.formList.forEach(item => {
            if(item.datatype === 2 && item.appid) {
              ids.push(item.appid)
            }
          })
          if (ids.length > 0) {
            reportList = await this.getReportList(ids)
          }
          for (let index = 0; index < printConfig.dataSource.formList.length; index++) {
            const item = printConfig.dataSource.formList[index];
            // datatype === 2 工坊
            const res = item.datatype === 2 ? await this.getWorkshop(item, printConfig, printFormdata, customData, reportList)
            : await this.getOtherTable(item, printConfig, printFormdata, spaceid, upaceid, customData)
            resOtherFormdata = { ...resOtherFormdata, ...res.resOtherFormdata }
            resOtherOriginalFormdata = { ...resOtherOriginalFormdata, ...res.resOtherOriginalFormdata }
            if (item.datatype === 2 && JSON.stringify(this.deptGroup) !== '{}') {
              resOtherFormdata.deptGroup = this.deptGroup
            }
          }
          // 结束
          console.log('其他表的数据了', resOtherFormdata, resOtherOriginalFormdata)
          resolve({otherData: resOtherFormdata, otherOriginalData: resOtherOriginalFormdata })
        } catch (error) {
          reject(error)
        }
      })()
    })
  }
  // 获取其他表的数据
  async getOtherTable (item, printConfig, printFormdata, spaceid, upaceid, customData) {
    return new Promise((resolve, reject) => {
      ( async () => {
        try {
          const resOtherFormdata = {}
          const resOtherOriginalFormdata = {}
          // 重置数据
          let parametersList = [] // 传参配置
          let parameters = {}
          const defaultKey = {
            '单号': '单号_orders',
            '状态': '状态_status',
            '提交时间': '发起时间_timeof',
            '申请人': '申请人_appuser',
            '归档状态': 'isarchive',
          }
          const query = {
            curpage: 0,
            pagesize: 500, // 打印最高获取500条,
            type: 0,
            approvalId: item.appid,
            query: null
            // 数字控件的值得是是列表且值是数字
            // query: '{"b1667182228972_text":["123"],"k1667182230130_number":[88,88]}'
          }
          // 传参
          let formList = printConfig.dataSource.formList ? printConfig.dataSource.formList : []
          formList.forEach(y => {
            // 抽取传参本表的公式
            if(y.appid == item.appid && y.parameters) {
              y.parameters.forEach(p=>{
                parametersList.push(p)
              })
            }
          })
          // 判断是否都是变量 如果条件都是变量那就不用重新请求了
          let isAllCustom = true
          parametersList.forEach(p => {
            const { chooseFrom, from } = p
            let key = `${from.title}_${from.type}`
            let name = from.name1 || from.name
            let otherName = defaultKey[chooseFrom.title] ? defaultKey[chooseFrom.title] : `${chooseFrom.title}_${chooseFrom.type}`
            let paramData
            if (from.datatype === 'custom') {
              // 本表的字段是变量
              paramData = getCustomVal({ name }, customData)
            } else {
              isAllCustom = false
              paramData = printFormdata[name] || printFormdata[key] || printFormdata[from.title]
            }
            if (chooseFrom.type === 'status') {
              // 申请状态
              paramData = this.getStatuasCode(paramData)
            }
            if (paramData || paramData === 0) {
              if (from.type !== 'number') {
                parameters[otherName] = Array.isArray(paramData) ? paramData : [paramData]
              } else {
                parameters[otherName] = [paramData, paramData]
              }
            }
          })
          query.query = parameters
          if (spaceid) {
            query.spaceid = spaceid
          }
          else if (upaceid) {
            query.upaceid = upaceid
          }
          // 获取他表数据
          if (isAllCustom && this.otherData[item.appid]) {
            resOtherFormdata[item.appid] = cloneDeep(this.otherData[item.appid])
            resOtherOriginalFormdata[item.appid] = cloneDeep(this.otherData[item.appid])
          } else {
            const { code, data } = await getoherappvaldatalist(query)
            if(code === 0){
              let list = []
              data.forEach(x=>{
                if(typeof x.formdata === 'string'){
                  list.push(JSON.parse(x.formdata))
                } else {
                  list.push(x.formdata)
                }
              })
              resOtherFormdata[item.appid] = this.getOtherDataFormat(list)
              resOtherOriginalFormdata[item.appid] = cloneDeep(list)
              this.otherData[item.appid] = cloneDeep(list)
            }
          }
          resolve({ resOtherFormdata, resOtherOriginalFormdata })
        } catch (error) {
          reject(error)
        }
      })()
      
    })
  }
  // 获取工坊作为他表时传参的数据
  async getWorkshop (item, printConfig, printFormdata, customData, reportList = []) {
    return new Promise((resolve, reject) => {
      ( async () => {
        try {
          const reportData = reportList.find(iter => { return iter.approvalReportId === item.appid })
          // await apiGetapprovalreport({ approvalReportId: item.appid }).catch(err => { console.log(err) })
          let variableconfig
          if (reportData && reportData.variableconfig) {
            variableconfig = JSON.parse(reportData.variableconfig)
          }
          let data = {
            approvalReportId: item.appid,
            curpage: 1,
            pagesize: 500 // 打印最高获取500条
          }
          const resOtherFormdata = { [item.appid]: {} }
          const resOtherOriginalFormdata = { [item.appid]: [] }
          this.deptGroup = {}
          // 传参
          let parameters = []
          let parametersList = [] // 传参配置
          let formList = printConfig.dataSource.formList ? printConfig.dataSource.formList : []
          formList.forEach(y=>{
            // 抽取传参本表的公式
            if (y.appid==item.appid&&y.parameters) {
              y.parameters.forEach(p=>{
                parametersList.push(p)
              })
            }
          })
          // 判断是否都是变量 如果条件都是变量那就不用重新请求了
          let isAllCustom = true
          parametersList.forEach(p => {
            const { chooseFrom, from, relation } = p
            let name = `${from.title}_${from.type}`
            let paramData
            if (from.datatype === 'custom') {
              // 本表的字段是变量
              paramData = getCustomVal({ name: from.name }, customData)
            } else {
              isAllCustom = false
              paramData = printFormdata[from.name1] || printFormdata[name] || printFormdata[from.title] || ''
            }
            if (chooseFrom.type === 'status') {
              // 申请状态
              isAllCustom = false
              paramData = this.getStatuasCode(paramData)
            }
            if (chooseFrom.datatype === 'custom') {
              // 如果传的是变量
              const index = variableconfig.findIndex(item => { return chooseFrom.name === item.name })
              if (index !== -1) {
                const iten = variableconfig[index]
                variableconfig[index].value = ['text', 'number', 'date'].includes(iten.type) && Array.isArray(paramData) && paramData.length === 1 ? paramData[0] : paramData
              }
            } else {
              const namaList = chooseFrom.name.split('.')
              const obj = {
                ttitle: namaList[namaList.length - 1],
                value: Array.isArray(paramData) ? paramData : [paramData],
                relation: relation
              }
              parameters.push(obj)
            }
          })
          data.value = parameters
          if (variableconfig) {
            data.customData = setCustomData(variableconfig)
          }
          // 获取他表数据
          if (isAllCustom && this.otherData[item.appid]) {
            resOtherFormdata[item.appid] = cloneDeep(this.otherData[item.appid])
            resOtherOriginalFormdata[item.appid] = cloneDeep(this.otherData[item.appid])
          } else {
            const res = await getapprovalreportdatalist(data)
            if(res.data && res.data.list.length>0){
              resOtherOriginalFormdata[item.appid] = res.data.list
              resOtherFormdata[item.appid] = this.getOtherDataFormat(res.data.list)
            }
          }
          resolve({ resOtherFormdata, resOtherOriginalFormdata})
        } catch (error) {
          reject(error)
        }
      } )()
      
    })
  }
  getOtherDataFormat (list) {
    let tempformdata = {}
    list.forEach(item => {
      const keys = Object.keys(item)
      keys.forEach(key=>{
        if (tempformdata[key] === undefined) {
          tempformdata[key] = []
          tempformdata[key].push(item[key])
        } else if (key.search('_json') !== -1) {
          tempformdata[key].push(...item[key])
        } else {
          tempformdata[key].push(item[key])
        }
      })
    })
    return cloneDeep(tempformdata)
  }
  // 获取全部数据的reportFormId
  async getReportFormId(appid, spaceid, upaceid) {
    const reportQuery = {
      curpage: 0,
      pagesize: 0,
      approvalId: appid
    }
    if (spaceid) {
      reportQuery.spaceid = spaceid
    }
    else if (upaceid) {
      reportQuery.upaceid = upaceid
    }

    const reportRes = await getopenreportformlist(reportQuery)
    if (reportRes.code == 0 && reportRes.data.length > 1) {
      const { reportFormId, lookqrcode, lookqrcodetypes, oqrcore, qrcodetypes } = reportRes.data[0]
      return { reportFormId, lookqrcode, lookqrcodetypes, oqrcore, qrcodetypes }
    } else {
      return {}
    }
  }
  // 获取本表某一条数据
  async getTableData (obj = { }) {
    let { appid, space, page = 0, reportFormId, query = {}, spaceid, upaceid, isFlow, isSinglePage } = obj
    // 获取reportFormId, 通过reportFormId去获取全部数据
    if (reportFormId === undefined) {
      const res = await this.getReportFormId(appid, spaceid, upaceid)
      reportFormId = res.reportFormId
    }

    if (reportFormId) {
      // 处理一下过滤条件 去除错误的值
      for (const key in query) {
        query[key] = query[key].filter(item => { return item || item === 0 })
        if (query[key].length === 0) {
          delete query[key]
        }
      }
      const fieldQuery = {
        type: 0,
        curpage: page,
        pagesize: 1,
        approvalId: appid,
        reportFormId,
        query
      }
      if (isSinglePage) {
        fieldQuery.curpage = 0
        fieldQuery.pagesize = 0
      }
      if(space || spaceid){
        fieldQuery.spaceid = typeof(spaceid) !== 'undefined' ? spaceid : localStorage.getItem('spaceid')
      }
      const fieldRes = await getapifielddatalist(fieldQuery)
      let resFormdata = {}
      let dataList = []
      // 返回全部数据的第一条
      if (fieldRes.data.length > 0) {
        const userapprovingId = fieldRes.data[0].userApprovingId
        dataList = fieldRes.data
        let query = {
          curpage: 0,
          pagesize: 0,
          approvalId: appid,
          userapprovingId,
        }
        if (!userapprovingId) {
          query = { approvalId: appid, approvingId: fieldRes.data[0].approvingId,  curpage: 0, pagesize: 0 }
        }
        const fn = userapprovingId ? getuserapprovinglist : getapproving
        const { data, code } = await fn(query)
        const defaultData = {}
        if (code === 0) {
          let flow = []
          let buttonList = []
          if (isFlow) {
            const flowQuery = {
              curpage: 0,
              pagesize: 0,
              approvalId: appid,
              approvingId: userapprovingId ? data[0].approvingId : fieldRes.data[0].approvingId,
            }

            const res = await getuserapprovinglist(flowQuery)
            if (res.code === 0) {
              const btnres = await apiGetapprovalselection({ approvalId: appid })
              if (btnres.code === 0) {
                for (let i in btnres.data) {
                  btnres.data[i] = btnres.data[i].split("|");
                }
                buttonList = btnres.data;
              }
            }
            flow = res.data
          }
          const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
          defaultKeyList.forEach(item => {
            defaultData[item] = this.handleDefaultKey(item, userapprovingId ? data[0] : data)
          })
          const formdata = userapprovingId ? JSON.parse(data[0].approving.formdata) : JSON.parse(data.formdata)
          resFormdata = {
            data: {
              ...formdata,
              ...defaultData,
            },
            total: fieldRes.total, // 全部数据总数
            flow,
            buttonList,
            appInfo: {
              approvalId: appid,
              userapprovingId: userapprovingId ? data[0].userapprovingId : '',
              approvingId: userapprovingId ? data[0].approvingId : fieldRes.data[0].approvingId,
            }
          }
        }
      }
      resFormdata.dataList = dataList
      return resFormdata
    } else {
      return {}
    }
  }
  // 获取应用二维码
  getAppCode (appInfo) {
    const { lookqrcode, lookqrcodetypes, oqrcore, qrcodetypes } = appInfo
    const codeObj = {}
    if (lookqrcode === 1 && lookqrcodetypes.length > 1) {
      // 查看二维码
      lookqrcodetypes.forEach(async item => {
        if (item == 1) {
          codeObj['lookcode_mini'] = await this.getCodeText({ type: 'lookcode', title: 'mini', ...appInfo})
        } else if (item == 2) {
          codeObj['lookcode_h5'] = await this.getCodeText({ type: 'lookcode', title: 'h5', ...appInfo})
        }
      })
    }
    if (oqrcore === 1 && qrcodetypes.length > 1) {
      qrcodetypes.forEach(async item => {
        // 数据二维码
        if (item == 2) {
          codeObj['datacode_mini'] = await this.getCodeText({ type: 'datacode', title: 'mini', ...appInfo })
        } else if (item == 4) {
          codeObj['datacode_h5'] = await this.getCodeText({ type: 'datacode', title: 'h5', ...appInfo })
        }
      })
    }
    return codeObj
  }
  getCodeText ({ type, title, approvalId, userapprovingId, approvingId, spaceid, upaceId }) {
    return new Promise( (resolve, reject) => {
      ( async () => {
        try {
          let qrcodeText
          const obj = type === 'lookcode' ? {
            approvalId,
            userapprovingId,
            approvingId
          } : {
            type: 1,
            channel: title,
            approvalId,
            approvingId
          }
          if (spaceid) obj.spaceid = spaceid
          if (upaceId) obj.upaceid = upaceId
          const itgeduUrl = ["http://app.itgedu.com.cn", "http://10.66.99.244", "http://10.66.99.244:8088"]
          const { code, data } = type === 'lookcode' ? await lookqrcoreddata(obj) : await qrcoreddata(obj)
          if (code === 0) {
            let url = itgeduUrl.includes(util.apiUrl()) ? 'https://admin.itgedu.com.cn:6352' : util.hfurl()
            let pageURL = title === 'h5' ? '/page/scanapp/scanapp' : '/static/getscanapp'
            qrcodeText = `${url}${pageURL}?code=${data}`
            if (type === 'lookcode') qrcodeText += `&mode=look`
            if (spaceid) {
              qrcodeText += `&spaceid=${spaceid}`
            } else if (upaceId) {
              qrcodeText += `&upaceid=${upaceId}`
            }
            resolve(qrcodeText)
          }
        } catch (error) {
          reject(error)
        }
      } )()
      
    })
  }
  // 获取本表为工坊时的数据
  async getShopData (obj = {}) {
    let { appid, page, search, isSinglePage } = obj
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          let workshopFormdata = {
            total: 0
          }
          const query = {
            approvalReportId: appid,
            curpage: page,
            pagesize: 1 // 打印最高获取500条
          }
          if (isSinglePage) {
            query.curpage = 0
            query.pagesize = 0
          }
          // 有设置传参
          const { datas, variableconfig } = await this.getReportSelect(appid)
          if (JSON.stringify(search) !== '{}') {
            // 获取工坊的显示值
            const parameters = []
            for (let key in search) {
              const field = datas.filter(item => {
                return item.title + '_' + item.type === key
              })
              let title = field.length > 0 ? field[0].name1 || field[0].name : key
              const namaList = title.split('.')
              if (namaList.length > 1) {
                title = namaList[namaList.length - 1]
              }
              let val = search[key]
              if (field.type === 'status') {
                // 申请状态
                val = this.getStatuasCode(val)
              }
              const index = variableconfig.findIndex(item => { return `${item.title}_${item.type}` === `${key}` })
              // 如果传的是变量
              if (index !== -1) {
                const iten = variableconfig[index]
                variableconfig[index].value = ['text', 'number', 'date'].includes(iten.type) && Array.isArray(val) && val.length === 1 ? val[0] : val
              } else {
                const obj = {
                  title,
                  value: Array.isArray(val) ? val : [val],
                  relation: 'in'
                }
                parameters.push(obj)
              }
            }
            query.value = parameters
          }
          if (variableconfig && variableconfig.length > 0) {
            query.customData = setCustomData(variableconfig)
          }
          const { data, total, code } = await getapprovalreportdatalist(query)
          let dataList = []
          const statusArr = ['进行中', '已通过', '未通过', '已撤回']
          if(code === 0 && data.list.length>0) {
            dataList = data.list
            workshopFormdata = dataList[0]
            // 要替换值的几个默认字段
            workshopFormdata['状态'] = statusArr[workshopFormdata['状态']]
            workshopFormdata['归档状态'] = workshopFormdata['状态'] ? '已归档' : '未归档'
            if (isSinglePage) {
              dataList = dataList.map(item => {
                item['状态'] = statusArr[item['状态']]
                item['归档状态'] = item['状态'] ? '已归档' : '未归档'
                return item
              })
            }
          }
          resolve({ data: workshopFormdata, total, dataList })
        } catch (error) {
          reject(error); // 错误通过标准的 reject 报告
        }
      })()
    })
  }
  // 获取工坊配置
  async getReportSelect (id) {
    const { code, data } = await apiGetapprovalreport({ approvalReportId: id }).catch(err => { console.log(err) })
    let datas = []
    let variableconfig = []
    if (code === 0) {
      const arr = JSON.parse(data.config)
      const i = arr.findIndex(its => its.type === 'output')
      if (i !== -1) {
        datas = arr[i].datas
      }
      if (data.variableconfig) {
        variableconfig = JSON.parse(data.variableconfig)
      }
    }
    return { datas, variableconfig }
  }
    // 批量获取工坊配置
  async getReportList (ids = []) {
    const { code, data } = await getapprovalreportlist({ approvalReportIds: ids.join(), curpage: 1, pagesize: ids.length }).catch(err => { console.log(err) })
    let datas = []
    if (code === 0) {
      datas = data
    }
    return datas
  }
  // 获取审批状态和归档状态的传参值
  getStatuasCode (val) {
    switch (val) {
      case '进行中':
        return 0
      case '已通过':
        return 1
      case '未通过':
        return 2
      case '已撤回':
        return 3
      case '已归档':
        return 1
      case '未归档':
        return 0
    }
  }
  getFilterData (sorceList, payloadData) {
    const { formdata, masterData, customData } = payloadData
    const result = {}
    for(const list of sorceList) {
      const field = list.children[0]
      let insertData = []
      const useData = field.isFilterData ? masterData : formdata[list.appid]
      insertData = this.getMatchData(list.condition, useData, customData)
      result[list.appid] = this.getOtherDataFormat(insertData)
    }
    return result
  }
  getMatchData (condition, dataList, customData) {
    const resDataList = []
    for (const data of dataList) {
      const res = isConditionAppen(condition, data, true, customData)
      if (res) {
        resDataList.push(data)
      }
    }
    return resDataList
  }
}

export default new DealPrintData()
